(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 76276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(84682);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ AuthFormWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65582);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62623);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28492);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);



var AuthFormWrapper = function(param) {
    var title = param.title, children = param.children;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    title,
                    " | ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "MUSIC CARE"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                sx: {
                    backgroundColor: "background.login",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    maxWidth: "sm",
                    sx: {
                        py: 10
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                pb: 4
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                alt: "FL Logo",
                                src: theme.palette.mode === "light" ? "/logos/music-care-block.png" : "/logos/music-care-block-white.png",
                                width: 185,
                                height: 75
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            sx: {
                                backgroundColor: "background.login",
                                boxShadow: "none"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    p: 3
                                },
                                children: children
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 21762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ FormikCheckField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20847);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76642);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74509);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






var FormikCheckField = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
        name: props.name,
        children: function(param) {
            var field = param.field, meta = param.meta;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        sx: {
                            mt: 1
                        }
                    }, props), {
                        control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            checked: meta.value,
                            color: "primary"
                        }, field))
                    })),
                    Boolean(meta.touched && meta.error) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        error: true,
                        children: meta.error
                    })
                ]
            });
        }
    });
};


/***/ }),

/***/ 33350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FormikTextField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22715);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var FormikTextField = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
        name: props.name,
        children: function(param) {
            var field = param.field, meta = param.meta;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                error: Boolean(meta.touched && meta.error),
                helperText: meta.touched && meta.error,
                variant: "outlined"
            }, field, props));
        }
    });
};


/***/ }),

/***/ 46648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ROUTES; }
/* harmony export */ });
/**
 * Global routes table
 */ var ROUTES = {
    // Apply
    APPLY: "/apply",
    CERTIFY: "/certify",
    GROW: "/grow",
    // Auth
    AUTH_LOGIN: "/",
    AUTH_FORGOT_PASSWORD: "/auth/forgot-password",
    AUTH_RESET_PASSWORD: "/auth/forgot-password-reset",
    AUTH_VERIFY_CODE: "/auth/verify-code",
    AUTH_VERIFY_EMAIL: "/auth/verify-email",
    AUTH_CREATE_ACCOUNT: "/register",
    REGISTER_PAYMENT: "/register/payment",
    REGISTER_PLAN_SELECTION: "/register/plan-selection",
    REGISTER_CONFIRMATION: "/register/confirmation",
    // Music care
    DASHBOARD: "/dashboard",
    CUSTOMERS_ROOT: "/customers",
    CUSTOMERS: "/customers",
    CUSTOMERS_CREATE: "/customers/create",
    CUSTOMERS_VIEW_SINGLE: "/customers/view",
    TRAIN: "/train",
    // Admin
    ADMIN_VIEW_USER: "/admin/view/",
    ADMIN: "/admin/",
    ADMIN_ORGANIZATIONS: "/admin/organizations",
    ADMIN_SCHOOLS: "/admin/schools",
    ADMIN_VIEW_SCHOOL: "/admin/school/",
    ADMIN_VIEW_ORG: "/admin/organization/",
    MEETING: "/meetings",
    MATERIALS: "/materials",
    SESSIONS: "/admin/sessions",
    ASSESSOR_MATERIALS: "/assessor-materials",
    FACILITATOR_MATERIALS: "/facilitator-materials",
    COURSE_CODES: "/course-codes",
    ASSIGN_CERTIFY_FACULTY: "/assign-certify-faculty",
    // Org cert
    ORG_CERT_PLAN: "/organization/plan",
    ORG_CERT_DRIVER: "/organization/driver",
    ORG_CERT_PORTFOLIO: "/organization/portfolio",
    ORG_CERT_ENGAGE: "/organization/engage",
    ORG_CERT_ENGAGE_LTD: "/organization/engageLimited",
    ORG_CERT_REGISTRY: "/organization/orgRegistry",
    ORG_CERT_GROW: "/organization/grow",
    ORG_CERT_RECERTIFY: "/organization/recertify",
    // School cert
    SCHOOL_CERT_PLAN: "/school/plan",
    SCHOOL_CERT_DRIVER: "/school/driver",
    SCHOOL_CERT_PORTFOLIO: "/school/portfolio",
    SCHOOL_CERT_ENGAGE: "/school/engage",
    SCHOOL_CERT_REGISTRY: "/school/registry",
    SCHOOL_CERT_GROW: "/school/grow",
    // Misc
    UNAUTHORIZED: "/unauthorized",
    PROFILE: "/profile",
    TEST_EDITOR: "/test-editor"
};


/***/ }),

/***/ 78470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46978);


var useAuth = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuth);


/***/ }),

/***/ 84682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(37786);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(50841);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/authentication/AuthFormWrapper.tsx
var AuthFormWrapper = __webpack_require__(6195);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(74509);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(69397);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./src/components/formik/FormikCheckField.tsx
var FormikCheckField = __webpack_require__(21762);
// EXTERNAL MODULE: ./src/components/formik/FormikTextField.tsx
var FormikTextField = __webpack_require__(33350);
;// CONCATENATED MODULE: ./src/components/authentication/create-account/index.tsx








var initialValuesOuter = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    policy: false,
    marketing: false,
    submit: null,
    captcha: ""
};
var validationSchemaOuter = es/* object */.Ry().shape({
    firstName: es/* string */.Z_().required("First name is required"),
    lastName: es/* string */.Z_().required("Last name is required"),
    email: es/* string */.Z_().email("Must be a valid email").max(255).required("Email is required"),
    password: es/* string */.Z_().min(8, "Must be at least 8 characters").max(255).required("Required").matches(RegExp("(?=.*[A-Z])", "gu"), "Must have at least one uppercase").matches(RegExp("(?=.*[a-z])", "gu"), "Must have at least one lowercase").matches(RegExp("(?=.*\\d)", "gu"), "Must have at least one digit").matches(RegExp("(?=.*\\W)", "gu"), "Must have at least one symbol"),
    confirmPassword: es/* string */.Z_().oneOf([
        es/* ref */.iH("password"),
        null
    ], "Passwords must match").required("Password is required"),
    policy: es/* boolean */.O7().oneOf([
        true
    ], "This field must be checked"),
    captcha: es/* string */.Z_().required("Required")
});
var _NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
var RegisterForm = function(param) {
    var onSubmit = param.onSubmit;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: initialValuesOuter,
        validationSchema: validationSchemaOuter,
        onSubmit: onSubmit,
        children: function(param) {
            var errors = param.errors, isSubmitting = param.isSubmitting, setFieldValue = param.setFieldValue;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                        name: "firstName",
                        fullWidth: true,
                        label: "First Name",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                        name: "lastName",
                        fullWidth: true,
                        label: "Last Name",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                        name: "email",
                        fullWidth: true,
                        label: "Email Address",
                        type: "email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                        name: "password",
                        fullWidth: true,
                        label: "Password",
                        type: "password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                        name: "confirmPassword",
                        fullWidth: true,
                        label: "Confirm Password",
                        type: "password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikCheckField/* FormikCheckField */.D, {
                        name: "policy",
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "I agree to the",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    color: "primary",
                                    component: "a",
                                    href: "#",
                                    children: "Terms and Conditions"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikCheckField/* FormikCheckField */.D, {
                        name: "marketing",
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            children: [
                                "I would like to receive marketing and promotional materials from",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "MUSIC CARE"
                                }),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                        name: "captcha",
                        children: function(param) {
                            var meta = param.meta;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                        sitekey: (_NEXT_PUBLIC_RECAPTCHA_SITE_KEY = "6LfK18wnAAAAANRl_BEllZSwbxUCzYTCAUeUwLA2") !== null && _NEXT_PUBLIC_RECAPTCHA_SITE_KEY !== void 0 ? _NEXT_PUBLIC_RECAPTCHA_SITE_KEY : "",
                                        onChange: function(e) {
                                            setFieldValue("captcha", e);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "error",
                                        children: meta.touched && meta.error ? "This field must be checked" : null
                                    })
                                ]
                            });
                        }
                    }),
                    errors.submit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            mt: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                            error: true,
                            children: errors.submit
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            color: "secondary",
                            disabled: isSubmitting,
                            fullWidth: true,
                            size: "large",
                            type: "submit",
                            variant: "contained",
                            children: "Sign up"
                        })
                    })
                ]
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(35713);
// EXTERNAL MODULE: ./src/queries/useResendConfirmationEmail.ts
var useResendConfirmationEmail = __webpack_require__(46649);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(46648);
;// CONCATENATED MODULE: ./src/icons/SendEmail.tsx


var SendEmailIcon = function(param) {
    var width = param.width, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 239 228",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.4297 98.5353C13.4297 94.8618 15.1934 91.4117 18.171 89.2605L112.87 20.8414C116.87 17.9515 122.272 17.9515 126.272 20.8414L220.971 89.2604C223.949 91.4117 225.713 94.8618 225.713 98.5353V136.6C225.713 142.919 220.59 148.042 214.27 148.042H24.872C18.5526 148.042 13.4297 142.919 13.4297 136.6V98.5353Z",
                fill: "#2F465E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter0_d_1384_2626)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: 58.1211,
                    y: 26.1572,
                    width: 122.901,
                    height: 117.822,
                    rx: 20.5961,
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter1_d_1384_2626)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.4297 96.2402L113.649 130.501C117.488 131.813 121.654 131.813 125.493 130.501L225.713 96.2402V191.692C225.713 201.803 217.516 210 207.405 210H31.7373C21.6263 210 13.4297 201.803 13.4297 191.692V96.2402Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter2_d_1384_2626)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.4297 102.614L113.649 136.875C117.488 138.187 121.654 138.187 125.493 136.875L225.713 102.614L225.714 191.692C225.714 201.803 217.517 209.999 207.406 209.999H31.7381C21.6272 209.999 13.4306 201.803 13.4305 191.692L13.4297 102.614Z",
                    fill: "#547190"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M77.2274 189.095H28.3285C28.0282 189.096 27.7308 189.037 27.4533 188.922C27.1758 188.807 26.9236 188.638 26.7112 188.425C26.4987 188.212 26.3302 187.959 26.2152 187.681C26.1002 187.402 26.041 187.104 26.041 186.803C26.041 186.501 26.1002 186.203 26.2152 185.924C26.3302 185.646 26.4987 185.393 26.7112 185.18C26.9236 184.967 27.1758 184.798 27.4533 184.683C27.7308 184.568 28.0282 184.509 28.3285 184.51H77.2274C77.5277 184.509 77.8251 184.568 78.1026 184.683C78.3801 184.798 78.6323 184.967 78.8447 185.18C79.0572 185.393 79.2257 185.646 79.3407 185.924C79.4557 186.203 79.5149 186.501 79.5149 186.803C79.5149 187.104 79.4557 187.402 79.3407 187.681C79.2257 187.959 79.0572 188.212 78.8447 188.425C78.6323 188.638 78.3801 188.807 78.1026 188.922C77.8251 189.037 77.5277 189.096 77.2274 189.095V189.095Z",
                fill: "#2F455D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.8723 179.238H28.3285C28.0282 179.238 27.7308 179.179 27.4533 179.064C27.1758 178.949 26.9236 178.78 26.7112 178.567C26.4987 178.355 26.3302 178.102 26.2152 177.823C26.1002 177.545 26.041 177.247 26.041 176.945C26.041 176.644 26.1002 176.345 26.2152 176.067C26.3302 175.789 26.4987 175.536 26.7112 175.323C26.9236 175.11 27.1758 174.941 27.4533 174.826C27.7308 174.711 28.0282 174.652 28.3285 174.652H45.8723C46.1726 174.652 46.47 174.711 46.7475 174.826C47.025 174.941 47.2772 175.11 47.4896 175.323C47.7021 175.536 47.8706 175.789 47.9856 176.067C48.1006 176.345 48.1598 176.644 48.1598 176.945C48.1598 177.247 48.1006 177.545 47.9856 177.823C47.8706 178.102 47.7021 178.355 47.4896 178.567C47.2772 178.78 47.025 178.949 46.7475 179.064C46.47 179.179 46.1726 179.238 45.8723 179.238Z",
                fill: "#2F455D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M113.45 116.833C111.197 116.837 109.003 116.106 107.2 114.749L107.088 114.665L83.5486 96.5768C82.4585 95.7385 81.5435 94.6929 80.856 93.4997C80.1684 92.3065 79.7218 90.989 79.5416 89.6226C79.3614 88.2561 79.4511 86.8674 79.8056 85.5358C80.1601 84.2041 80.7725 82.9556 81.6078 81.8615C82.4431 80.7674 83.4849 79.8491 84.6738 79.159C85.8627 78.469 87.1753 78.0208 88.5368 77.8399C89.8983 77.659 91.2819 77.749 92.6088 78.1048C93.9356 78.4606 95.1796 79.0753 96.2697 79.9136L111.517 91.6473L147.548 44.4864C148.384 43.3926 149.426 42.4746 150.615 41.785C151.804 41.0954 153.117 40.6476 154.478 40.4672C155.84 40.2868 157.224 40.3774 158.55 40.7337C159.877 41.09 161.121 41.7051 162.21 42.5438L161.986 42.8491L162.216 42.5483C164.415 44.244 165.853 46.7458 166.216 49.5046C166.579 52.2635 165.837 55.0541 164.152 57.2643L121.771 112.737C120.79 114.015 119.53 115.05 118.087 115.76C116.644 116.47 115.058 116.838 113.45 116.833V116.833Z",
                fill: "#399DEB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_d_1384_2626",
                        x: 28.3711,
                        y: 0.984196,
                        width: 182.4,
                        height: 177.322,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: 4.57691
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: 14.875
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1384_2626"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1384_2626",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_d_1384_2626",
                        x: 0.843172,
                        y: 88.2306,
                        width: 237.456,
                        height: 138.933,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: 4.57691
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: 6.29326
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1384_2626"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1384_2626",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter2_d_1384_2626",
                        x: 0.843172,
                        y: 94.6047,
                        width: 237.456,
                        height: 132.558,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: 4.57691
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: 6.29326
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1384_2626"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1384_2626",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SendEmail = (SendEmailIcon);

;// CONCATENATED MODULE: ./src/components/authentication/create-account/ConfirmEmailDialog.tsx











var ConfirmEmailDialog = function(param) {
    var open = param.open, email = param.email;
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useResendConfirmationEmail/* useResendConfirmationEmailMutation */.N)(), 1), resendEmailConfirmation = ref[0];
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var tryResendConfirmationEmail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!email) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            resendEmailConfirmation({
                                variables: {
                                    email: email
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        enqueueSnackbar("Resent!", {
                            variant: "success"
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        enqueueSnackbar("An Error Occurred", {
                            variant: "error"
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function tryResendConfirmationEmail() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: open,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        style: {
            width: "400px",
            margin: "0 auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    align: "center",
                    color: "textPrimary",
                    style: {
                        fontSize: "32px",
                        fontWeight: 700,
                        marginBottom: "20px"
                    },
                    children: "Please verify your email"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SendEmail, {
                        width: 300,
                        height: 200
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    align: "center",
                    color: "textPrimary",
                    style: {
                        fontSize: "18px",
                        fontWeight: 400,
                        lineHeight: "27px",
                        marginTop: "20px"
                    },
                    children: "Please click the verification link in the email, and then sign in to continue."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        mt: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        style: {
                            width: "60%",
                            marginLeft: "20%"
                        },
                        size: "large",
                        type: "submit",
                        variant: "contained",
                        onClick: function() {
                            router.push({
                                pathname: "".concat(routes/* ROUTES.AUTH_LOGIN */.Z.AUTH_LOGIN)
                            });
                        },
                        children: "Sign in"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    align: "center",
                    color: "textPrimary",
                    style: {
                        fontSize: "18px",
                        fontWeight: 400,
                        lineHeight: "27px",
                        marginTop: "20px"
                    },
                    children: [
                        "Didn’t receive an email? ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            color: "primary",
                            component: "a",
                            style: {
                                textDecoration: "none",
                                cursor: "pointer"
                            },
                            onClick: function() {
                                tryResendConfirmationEmail();
                            },
                            children: "Resend"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(78470);
;// CONCATENATED MODULE: ./src/pages/register/index.tsx













var CreateAccount = function() {
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var router = (0,next_router.useRouter)();
    var ref = (0,useAuth/* default */.Z)(), register = ref.register, login = ref.login, user = ref.user;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), awaitingVerification = ref1[0], setAwaitingVerification = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), timer = ref2[0], setTimer = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), emailAddress = ref3[0], setEmailAddress = ref3[1];
    var attemptLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(email, password) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            login({
                                email: email,
                                password: password
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function attemptLogin(email, password) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var timeout, err, message;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            register(values)
                        ];
                    case 1:
                        _state.sent();
                        setEmailAddress(values.email);
                        enqueueSnackbar("Account created", {
                            variant: "success"
                        });
                        setAwaitingVerification(true);
                        timeout = window.setInterval(function() {
                            attemptLogin(values.email, values.password);
                        }, 4000);
                        setTimer(timeout);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        message = err.message.split(":");
                        enqueueSnackbar("Could not create account: ".concat(message[1]), {
                            variant: "error"
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        // There is an interval
        if (user && typeof timer === "number") {
            window.clearInterval(timer);
            setTimer(0);
            var plan = router.query.plan;
            if (plan && typeof plan === "string") {
                router.push({
                    pathname: routes/* ROUTES.REGISTER_PLAN_SELECTION */.Z.REGISTER_PLAN_SELECTION,
                    query: {
                        plan: plan
                    }
                });
            } else {
                router.push(routes/* ROUTES.REGISTER_PLAN_SELECTION */.Z.REGISTER_PLAN_SELECTION);
            }
        } else if (user && !timer) {
            router.push(routes/* ROUTES.AUTH_LOGIN */.Z.AUTH_LOGIN);
        }
    }, [
        user,
        router,
        timer
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthFormWrapper/* AuthFormWrapper */.f, {
        title: "Create Account",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmEmailDialog, {
                open: awaitingVerification,
                email: emailAddress
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    mb: 3,
                    backgroundColor: "primaryMain"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "textPrimary",
                            gutterBottom: true,
                            variant: "h3",
                            children: "Create an Account"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            color: "textSecondary",
                            variant: "body1",
                            children: [
                                "Already have an account? ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    color: "primary",
                                    component: "a",
                                    href: routes/* ROUTES.AUTH_LOGIN */.Z.AUTH_LOGIN,
                                    children: "Sign in"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    flexGrow: 1,
                    backgroundColor: "primaryMain"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm, {
                    onSubmit: handleSubmit
                })
            })
        ]
    });
};
/* harmony default export */ var register = (CreateAccount);


/***/ }),

/***/ 46649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useResendConfirmationEmailMutation; }
/* harmony export */ });
/* unused harmony export RESEND_CONFIMATION_EMAIL_MUTATION */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75063);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50319);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ResendConfirmationEmail($email: String!) {\n    resendConfirmationEmail(email: $email) {\n      message\n      success\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RESEND_CONFIMATION_EMAIL_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var useResendConfirmationEmailMutation = function(options) {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)(RESEND_CONFIMATION_EMAIL_MUTATION, options);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8598,7711,5675,4097,4914,6991,7691,9402,9774,2888,179], function() { return __webpack_exec__(76276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);